import React, { useState } from 'react';
import { CODE_LENGTH } from './components/OtpInput/OtpInput.config';
import InitiateNewRegistration from './InitiateNewRegistration';
import { generateOtp, startProcess } from '../../services/apis';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../helpers/showToast';
import { useKeycloak } from '../../hooks/useKeycloak';

const InitiateNewRegistrationContainer = ({ ...restProps }) => {
  const [code, setCode] = useState(
    Array.from(Array(CODE_LENGTH)).map(() => ''),
  );
  const [loading, setLoading] = useState(false);

  const { i18n, t } = useTranslation();
  const history = useNavigate();

  const { logout, userInfo } = useKeycloak();

  const handleGenerate = async (noOfOTPs) => {
    if (userInfo) {
      setLoading(true);
      await generateOtp(userInfo.tax_number, noOfOTPs)
        .then((resp) => {
          const otpArray = resp?.data?.OTPs?.map((otp) => otp.split(''));
          setCode(otpArray);
        })
        .catch((err) => {
          if (err?.status === 401) {
            logout();
          }
          throw new Error(err.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleHomeClick = () => {
    history('/' + i18n.language);
  };

  return (
    <InitiateNewRegistration
      onGenerate={handleGenerate}
      {...restProps}
      code={code}
      loading={loading}
      onHomeClick={handleHomeClick}
    />
  );
};

export default React.memo(InitiateNewRegistrationContainer);
